import {siteAccessCode, siteName} from "../database/apiv2SiteAccessor"
import { timeAgo } from "../timeFunctions/timeFns"

export function mostRecentPush (site, login) {
  let cache = mostRecentRead(login)
  cache = updateCache (cache, site)
  saveCache ('mru'+login, cache)
  return cache
}
export function mostRecentRead (login) {
  return leastAged(readItem('mru'+login))
}
export function addFavorite(site, login) {
  const fav = favRead(login)
  const cache = updateCache (fav, site)
  faveSave(cache, login)
}
export function favRead (login) {
  return readItem('fav'+login)
}
function readItem (name) {
  try {
    const strFav = localStorage.getItem(name)
    const fav = JSON.parse(strFav)
    return Array.isArray(fav) ? fav : []
  }
  catch (e) {
    console.log (e)
    return []
  }
}
export function faveSave(fav, login) {
  saveCache('fav'+login, fav)
}
function updateCache (cache, site) {
  const pushObj = filterSite(cache, site)
  const newObj = {'ac': siteAccessCode(site), 'name': siteName(site), 'dt': new Date()}
  pushObj.push(newObj)
  return pushObj
}
function saveCache (name, cacheObj) {
  const pushStr = JSON.stringify (cacheObj)
  localStorage.setItem (name, pushStr)
}
function filterSite (cache, site) {
  return cache.filter(s => s?.ac !== siteAccessCode(site))
}
function leastAged (cache) {
  return cache.filter(s => timeAgo(s?.dt) < 86400000 * 30)
}
